import '../styles/ClickableButton.css';
import { ANIMATION_TYPES } from '../CONSTANTS'
import { useNavigate } from 'react-router';

export function CreditsButton () {

    let navigate = useNavigate();

    // Handle mouse-over animations
    function mouseEnter () {
        let button = document.getElementById('profile-button-credits')
        button.classList.add(ANIMATION_TYPES.SECONDARY)
        button.addEventListener('animationend', () => {
            button.classList.remove(ANIMATION_TYPES.SECONDARY)
        });
    }

    // Send user to the appropriate URL on click
    function onClick () {
        navigate('/credits')
    }

    return (
        <div 
            id='profile-button-credits'
            className='animate__animated'
            onMouseEnter={mouseEnter}
            onClick={onClick}
        >
            <button className='credits-button'>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><title xmlns="">info-outline</title><path d="M11 17h2v-6h-2zm1.713-8.287Q13 8.425 13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9t.713-.288M12 22q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/></svg>
            </button>
        </div>
    )
}